import React from 'react';
import { useSelector } from 'react-redux';
import { getShowChartingOptions } from '@/store-selectors';
import { TABLE } from '@/components/charting/chartType.constants';
import { Table as TableBase } from '../buttons';
import {
  useDeriveHeadings,
  useDerivePresentation,
  useHandlePresentationChange,
} from './hooks';

export const Table = () => {
  const headings = useDeriveHeadings();
  const handleChange = useHandlePresentationChange(TABLE);
  const areChartingOptionsShown = useSelector(getShowChartingOptions);
  const presentation = useDerivePresentation(headings);

  const isActive = areChartingOptionsShown && presentation === TABLE;

  return <TableBase onClick={handleChange} $active={isActive} />;
};
